import selectMinigame from "./selectMinigame";
import generateTask from "./utility/generateTask";
import endGameFull from "./endGameFull";

import { TaskId, ConstrainedMinigamesConfigId, MinigameId, AtomicTaskId } from "./TypeDefinition";
/**
 * Get names of all completed minigames in history.
 * @param {[HistoryRecord]} history - state.object.history object
 * @return array of names of minigames.
 */
function completedMinigames(history) {
	return history.filter(({ completed }) => completed).map(({ minigame: { name } }) => name);
}

function finishedMinigames(history) {
	return history.filter(({ finished }) => finished).map(({ minigame: { name } }) => name);
}

/**
 * Exclude all completed minigames from the list of all minigames.
 * @param {[Task]} allMinigameNames - array of minigames
 * @param {[HistoryRecord]} history - state.object.history
 * @return array of minigames
 */
function dropCompleted(allMinigameNames, history) {
	const completed = completedMinigames(history);
	return allMinigameNames.filter(name => !completed.includes(name));
}

function dropFinished(allMinigameNames, history) {
	const finished = finishedMinigames(history);
	return allMinigameNames.filter(name => !finished.includes(name));
}

/**
 * Get next minigame with generated parameters.
 * @param {ConstrainedMinigamesConfig} config - minigames config
 * @param state - state
 * @returns {Minigame} a minigame which is a chosen task extended with `form` attribute
 */
function getNextMinigame(config, state) {
	ConstrainedMinigamesConfigId(config);
	const history = state.objects.history;
	let minigame = selectMinigame(config, state, history);
	if (minigame === undefined) {
		if(config.type !== "menu"){
			state.objects.endofGame = true;
			minigame = endGameFull;
		}
		else {
			return undefined;
		}
	}
	if(config.type !== "menu") state.objects.currentMinigame = minigame.name;
	minigame = generateTask(minigame, state);
	TaskId(minigame);
	//if (minigame.components) return CompositeTaskId(minigame);
	AtomicTaskId(minigame);
	const form = minigame.generateParams(minigame, state);
	form.helper = state.objects.help;
	if (!form.type) form.type = minigame.minigameType;
	return MinigameId({ ...minigame, form });

}

export default getNextMinigame;
